import React, { useEffect } from 'react';
import './Contact.scss';
import './mediaQuery.scss';
import { setWechatShare } from '../../utils';

interface Props {
  getPath: (path: string) => void;
}

type Position = [number, number];
type InfoContent = string | HTMLElement;

interface ImapConfig {
  center: Position;
  zoom: number;
}

interface ImarkerConfig {
  map: object;
  position: Position;
  title: string;
}

interface IinfoWindowConfig {
  content: InfoContent;
  anchor: string;
  offset: (x: number, y: number) => any;
}

const AMap = (window as any).AMap;

const mapCreator = (
  id: string,
  position: Position,
  title: string,
  infoContent: InfoContent
): object | null => {
  const mapConfig: ImapConfig = {
    center: position,
    zoom: 16,
  };
  const map = new AMap.Map(id, mapConfig);
  const markerConfig: ImarkerConfig = {
    map,
    position,
    title,
  };
  const marker = new AMap.Marker(markerConfig);

  map.add(marker);

  const infoWindowConfig: IinfoWindowConfig = {
    content: infoContent,
    offset: new AMap.Pixel(0, -32),
    anchor: 'bottom-center',
  };

  const infoWindow = new AMap.InfoWindow(infoWindowConfig);

  AMap.event.addListener(marker, 'click', function() {
    infoWindow.open(map, marker.getPosition());
  });

  return map;
};

const title = '联系我们-懒熊体育-让体育产业高效连接';

const Contact: React.FC<Props> = props => {
  useEffect(() => {
    props.getPath('/contact');
    document.title = title;

    setWechatShare({
      title,
    });

    setTimeout(() => {
      mapCreator(
        'map-beijing',
        [116.428222,39.894411],
        '懒熊体育',
        `<p class='input-item' style='padding-right: 5px;' >北京市东城区广渠门内大街45号雍贵中心D座304室</p>`
      );

    }, 100);
  }, [props]);

  return (
    <div className="Contact">
      <div className="content">
        <h1>联系我们</h1>
        <div className="info">
          <div className="tel">电话：010-87945186</div>
          <div className="mail">邮箱：zx@lanxiongsports.com</div>
          <div className="address">
            <p>地址：北京市东城区广渠门内大街45号雍贵中心D座304室</p>
            <div className="maps">
              <div className="map-beijing map" id="map-beijing"></div>
            </div>
          </div>
        </div>
        <div className="contact-wechat">
          <h4>微信：</h4>
          <ul>
            <li>
              <img
                src="http://imgcdn.lanxiongsports.com/upload/lx-service/qrcode_sw.jpg"
                alt="商务合作"
              />
              <p>商务合作</p>
            </li>
            <li>
              <img
                src="http://imgcdn.lanxiongsports.com/upload/lx-service/qrcode_zk.jpeg"
                alt="懒熊智库"
              />
              <p>懒熊智库</p>
            </li>
            <li>
              <img
                src="http://imgcdn.lanxiongsports.com/upload/lx-service/qrcode_baodao.jpeg"
                alt="寻求报道"
              />
              <p>寻求报道</p>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Contact;
